import { CookieService } from 'ngx-cookie-service';
import { ConfigurationService } from '../../services/configuration.service';
import { MainMenuService } from './api/main-menu.service';
import { CustomerMainMenuFacade } from './services/customer-main-menu.facade';

export const mainMenuFacadeFactory = (
  configurationService: ConfigurationService,
  mainMenuService: MainMenuService,
  cookieService: CookieService,
) => new CustomerMainMenuFacade(configurationService, mainMenuService, cookieService);
